module.exports = __webpack_public_path__ + "img/whathot_big01_words.af7c9196.jpg";